<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t(`report.${wholeType}_report`)"
    icon="res-report-setting"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions :options="singleActions" :row="detailData" button-type="link" button-size="small" />
    </template>
    <component :res-id="data.id" :is="params.windowData.currentTab" :id="listId" :data="detailData" :onManager="onManager" :getParams="getParams" :wholeType="wholeType" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'
import ColumnsMixin from '../mixins/columns'
import Detail from './Detail'
import SendRecord from './Records'
import SingleActionsMixin from '../mixins/singleActions'

export default {
  name: 'MonthReportSidePage',
  components: {
    Detail,
    SendRecord,
    Actions,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {
      detailTabs: [
        { key: 'detail', label: this.$t('common_386') },
        { key: 'send-record', label: this.$t('report.send_record') },
        { label: this.$t('compute.text_240'), key: 'event-drawer' },
      ],
    }
  },
  computed: {
    getParams () {
      if (this.params.windowData.currentTab === 'send-record') {
        return {
          session_id: this.detailData.id,
        }
      }
      return {}
    },
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'event-drawer':
          return 'EventListForMonthReportSidePage'
        case 'send-record':
          return 'MonthReportRecordsList'
        default:
          return ''
      }
    },
    wholeType () {
      return this.params.wholeType
    },
  },
}
</script>
